import React from 'react';
import { AlertCircleIcon } from 'lucide-react';
export function ProblemSection() {
  const symptoms = ['Cansancio constante', 'Aumento de peso sin razón', 'Inflamación abdominal', 'Cambios de humor', 'Problemas para dormir', 'Ansiedad o irritabilidad', 'Falta de energía durante el día'];
  return <section className="py-16 px-4 max-w-3xl mx-auto" data-id="element-127">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-8" data-id="element-128">
        Si en los últimos años empezaste a sentir que tu cuerpo cambió y no
        entendés por qué, no estás sola.
      </h2>

      <p className="text-lg text-gray-700 mb-8 text-center" data-id="element-129">
        Muchas mujeres comienzan a experimentar síntomas que aparecen de la
        nada:
      </p>

      <div className="bg-white rounded-2xl p-6 md:p-8 shadow-lg border border-brand-green/10" data-id="element-130">
        <ul className="space-y-4" data-id="element-131">
          {symptoms.map((symptom, index) => <li key={index} className="flex items-start gap-3" data-id="element-132">
              <AlertCircleIcon className="w-6 h-6 text-brand-red flex-shrink-0 mt-0.5" data-id="element-133" />
              <span className="text-lg font-medium text-gray-800" data-id="element-134">
                {symptom}
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}